import React from 'react';
import {
  Stack,
  IconButton,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useModals } from '@mattjennings/react-modal-stack';
import Iconify from '../Iconify';

const AlertDialog = ({
  open,
  onConfirm = () => {},
  title,
  text,
  cancelLabel,
  acceptLabel,
  blockClose = false,
}) => {
  const { closeModal } = useModals();

  if (!open) {
    return null;
  }

  const handleClose = () => {
    closeModal();
  };

  const handleAcept = () => {
    closeModal();
    onConfirm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Stack
        gap={2}
        sx={{
          padding: { xs: '12px 24px 24px 24px', sm: '14px 32px 32px 32px' },
        }}
      >
        {blockClose && (
          <Stack
            direction="row"
            justifyContent="flex-end"
            sx={{
              mr: -1,
              mb: '-16px',
            }}
          >
            <IconButton onClick={closeModal}>
              <Iconify icon="icon-park:close-small" />
            </IconButton>
          </Stack>
        )}
        <Stack gap={3}>
          <Stack gap={1}>
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: '16px', md: '18px' },
                lineHeight: '140%',
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: '14px', lineHeight: '140%' }}
            >
              {text}
            </Typography>
          </Stack>
          <Stack
            direction={{ xs: 'column-reverse', sm: 'row' }}
            justifyContent="flex-end"
            gap={1}
          >
            {cancelLabel && (
              <Button onClick={handleClose}>{cancelLabel}</Button>
            )}
            <Button onClick={handleAcept} autoFocus variant="contained">
              {acceptLabel}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default AlertDialog;
